const getParamName = (flow) => `is${flow}DrawerOpen`;
export const SET_DRAWER_STATE = 'SET_DRAWER_STATE';

export const ADD_TASK_DRAWER = getParamName('AddTask');
export const DRAWER_DEAL_SUBMISSION_MATCH = getParamName('DealSubmissionMatch');

export const ACTIVITY_DEAL_SUBMISSION_DRAWER = getParamName(
  'ActivityDealSubmission',
);
